module.exports = "https://static.futunn.com/components/common-offline-activity-ticket/images/unsign.89c0812731.png";